<template>
    <el-row :gutter="20" class="maintain-param">
        <el-col :span="12" v-for="param in params" class="maintain-param-item">
            <el-row class="maintain-param-item-info">
                <el-col :span="8"><span class="label">参数说明：</span>
                    <p class="name">{{param.name}}</p></el-col>
                <el-col :span="4"><span class="label">清洗杯数：</span>
                    <el-input v-model.number="param.coupons" type="number" class="input"></el-input>
                </el-col>
                <el-col :span="12"><span class="label">提示文字：</span>
                    <el-input v-model="param.text" placeholder="请输入" class="info"></el-input>
                </el-col>
            </el-row>
        </el-col>
    </el-row>

</template>

<script>
    export default {
        name: '',
        components: {},
        props: {
            params: {
                type: Array,
                default: () => []
            }
        },
        mounted: function () {
        },
        data: function () {
            return {
            }
        },
        methods: {},
    }
</script>

<style lang="scss">
    .maintain-param {
        .maintain-param-item {
            text-align: center;
            margin-bottom: $padding;
            .maintain-param-item-info {
                margin: 0 $padding-5;
                border: 1px solid;
                padding: $padding-5 0;
            }
            .name {
                margin-top: $padding;
                font-size: .8rem;
            }
            .label {
                display: inline-block;
                width: 100%;
                font-size: .6rem;
                color: $f_sec_color;
            }
            .input {
                max-width: 7.5rem;
                input {
                    text-align: center;
                    color: $f_color;
                }
            }
            .info {
                margin-left: $padding;
                max-width: 10rem;
                input {
                    text-align: center;
                    color: $f_color;
                }
            }
        }
    }
</style>
